import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 360px;
  text-align: center;
  margin: 10px auto;
`;

const Label = styled.div`
  margin: auto;
  margin-top: 10px;
  color: ${props => props.theme.primary};
  font-size: 16px;
`;

const Field = styled.div`
  margin: auto;
  margin-top: 10px;
  color: ${props => props.theme.secondary};
  font-size: 18px;
`;

const DeviceCard = ({ device }) => (
  <Wrapper>
    <Label>id</Label>
    <Field>{device.id || '-'}</Field>
    <Label>name</Label>
    <Field>{device.deviceName || '-'}</Field>
    <Label>status</Label>
    <Field>{device.lifeCycleStatus || '-'}</Field>
    <Label>organization</Label>
    <Field>{device.deviceOrganization || '-'}</Field>
  </Wrapper>
);

export default translate()(DeviceCard);
